import i18n from 'i18next';
import React from 'react';

import FormTitleSession from '@/components/FormTitleSession';
import InfoBox from '@/components/InfoBox';
import ExportEntitySelect from '@/modules/configuration/components/ExportEntitySelect';
import TechParkSelect from '@/modules/configuration/components/TechParkSelect';
import ProposalEmailOrSite from '@/modules/proposalRequest/components/ProposalEmailOrSite';
import ProposalTrademark from '@/modules/proposalRequest/components/ProposalTrademark';
import QuestionWithDetails, {renderQuestionWithDetails} from '@/modules/proposalRequest/components/QuestionWithDetails';
import createFormFieldset from '@/utils/createFormFieldset';
import {validations} from '@/utils/fields';

export const fields = [
  {
    key: 'documentation2',
    colSpan: 2,
    // eslint-disable-next-line react/display-name
    render: () => <FormTitleSession translate={'proposalRequest'} title={'steps.request'}/>
  },
  {
    key: 'haveTradeMark',
    placeholder: 'defaultPlaceholder',
    required: false,
    widget: ProposalTrademark,
    widgetProps: {
      label: 'proposalRequest.form.general.haveTradeMark.label',
      size: 'large',
      translate: 'proposalRequest',
      type: 'text',
    },
    rules: [
      {
        validator: (rule, value) => {
          return new Promise((resolve, reject) => {
            if (value?.active && !value?.file)
              reject(new Error(i18n.t('validateMessages.required')));
            else {
              resolve();
            }
          });
        }
      },
    ]
  },
  {
    key: 'activityDeclaration',
    render: createFormFieldset({
      title: 'proposalRequest.form.general.groups.activities',
      help: 'proposalRequest.form.general.groups.activities_help',
      translation: 'proposalRequest'
    }),
  },
  {
    key: 'extraInfo',
    render: createFormFieldset({
      title: 'proposalRequest.form.general.groups.extra',
      translation: 'proposalRequest'
    }),
  },
  {
    key: 'email',
    widget: ProposalEmailOrSite,
    widgetProps: {
      label: 'proposalRequest.form.general.email.title',
      translate: 'proposalRequest',
      extraLabel: 'proposalRequest.form.general.email.name',
      placeholderText: 'proposalRequest.form.general.email.label',
      size: 'large',
      rules: [{type: 'email'}]
    }
  },
  {
    key: 'webSite',
    widget: ProposalEmailOrSite,
    widgetProps: {
      label: 'proposalRequest.form.general.webSite.title',
      translate: 'proposalRequest',
      extraLabel: 'proposalRequest.form.general.webSite.name',
      placeholderText: 'proposalRequest.form.general.webSite.label',
      size: 'large',
      rules: [validations.url()]
    },
  },
  {
    key: 'customNotarialProcess',
    label: 'proposalRequest.form.general.customNotarialProcess.label',
    render: renderQuestionWithDetails,
    widgetProps: {
      requireLocation: false,
      translate: 'proposalRequest',
      extraLabel: 'proposalRequest.form.general.customNotarialProcess.name',
      size: 'large',
      cmpProps: {
        extra: <InfoBox title={'proposalRequest.form.general.customNotarialProcess.help'}
          translate={'proposalRequest'}/>
      }
    }
  },
  {
    key: 'hasExported',
    widget: QuestionWithDetails,
    widgetProps: {
      label: 'proposalRequest.form.general.hasExported.label',
      translate: 'proposalRequest',
      extraLabel: 'proposalRequest.form.general.hasExported.name',
      size: 'large',
      placeholderText: 'selectPlaceholder',
      customWhereCmp: ExportEntitySelect
    }
  },
  {
    key: 'localDevelopment',
    label: 'proposalRequest.form.general.localDevelopment.label',
    render: renderQuestionWithDetails,
    widgetProps: {
      requireLocation: true,
      translate: 'proposalRequest',
      extraLabel: 'proposalRequest.form.general.localDevelopment.name',
      size: 'large'
    },
  },
  {
    key: 'incubating',
    widget: QuestionWithDetails,
    dependencies: ['incubating'],
    shouldUpdate: () => true,
    widgetProps: {
      label: 'proposalRequest.form.general.incubating.label',
      extraLabel: 'where',
      translate: 'proposalRequest',
      placeholderText: 'selectPlaceholder',
      size: 'large',
      customWhereCmp: TechParkSelect
    }
  }
];

export const fieldsTCP = [
];
